import { Skeleton } from '@/components/ui/skeleton'

export const ExternalBackupsFallback = () => (
  <div className="rounded-lg border">
    <div className="flex items-center justify-between gap-4 p-4">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-3.5 w-36" />
        <Skeleton className="h-5 w-80 max-w-full" />
      </div>
      <Skeleton className="h-[1.15rem] w-8 shrink-0 rounded-full" />
    </div>
  </div>
)
